import React from "react";
import "./Monostate.css"
import MonostateExample from "./MonostateExample";

class Monostate extends React.Component {
    constructor(props) {
        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        this.exampleObject = new MonostateExample();
        this.exampleObject2 = new MonostateExample();

        console.log("getStateVar() returned " + this.exampleObject.getStateVar());
        console.log("getStateVar() returned " + this.exampleObject2.getStateVar());

        // Setting the initial state of the NormalForms component
        this.state =
            {
                stateCount1: this.exampleObject.getStateVar(),
                stateCount2: this.exampleObject2.getStateVar()
            };


    } // End of constructor()



    onTopClick = () => {
        this.intro.scrollIntoView(true);
    }

    firstClick = (event) => {
        console.log("First was clicked.");
        this.first.scrollIntoView();
    }

    secondClick = (event) => {
        console.log("Second was clicked.");
        this.second.scrollIntoView();
    }

    thirdClick = (event) => {
        console.log("Third was clicked.");
        this.third.scrollIntoView();
    }

    handleIncrement1 = (event) => {
        this.exampleObject.incrementStateVar();
        this.setState({
            stateCount1: this.exampleObject.getStateVar(),
            stateCount2: this.exampleObject2.getStateVar()
        });
    }

    handleIncrement2 = (event) => {
        this.exampleObject2.incrementStateVar();
        this.setState({
            stateCount1: this.exampleObject.getStateVar(),
            stateCount2: this.exampleObject2.getStateVar()
        });
    }

    render() {
        return (

            <div className='NormalFormsMain scroll-div'>

                <div ref={node => this.buttons = node} className="fuck">
                    <button onClick={this.onTopClick}>Intro </button>
                    <button onClick={this.firstClick}>Example Code </button>
                    <button onClick={this.secondClick} className="BottomButton">Bottom </button>
                    <button onClick={this.secondClick} className="PhoneButton">Web Sample </button>
                 </div>

                <div ref={node => this.container = node} className="NormalFormsFollowing scroll-div">
                    <div ref={node => this.tippyTop = node}> </div>

                    {/*  *******************Intro Div ***************************/}
                    <div className="scroll-div" ref={node => this.intro = node}>
                        <h5>Singleton / Monostate Design Pattern</h5>

                        <p>The singleton design pattern is one of the design patterns discussed in
                            the book, <span className="BookTitls"> Design Patterns: Elements of Reusable Object-Oriented Software </span>
                            by Erich Gamma, Richard Helm, Ralph Johnson, John Vlissides.  This is a common
                             design pattern used in C++ and Java.</p>

                        <p>The singleton allows only one instantiation of a class and is often used to
                            model resources or do module management within a system.</p>

                        <p>An alternative to the singleton pattern is a pattern called the "Monostate Design Pattern."
                            I prefer the monostate pattern to the singleton pattern in general and in the case of
                            the Javascript programming I STRONGLY prefer the monostate pattern to the singleton pattern. </p>

                        <p>As the name implies, there is only one set of state variables in this design
                            pattern.  Many objects can be created and none of the objects have any
                            instance data attributes at all, while all objects of the class have
                            access to the state variables.</p>

                        <p>Conceptually, each instance of the class represents a liaison or a service
                            object.  Think of a server in a restaurant.  Each object that is an instance
                            of the monostate class is your server in the sense that the instance will take
                            your request to the one shared state and do your bidding.  Or, each instance
                            is your liasison to the shared class state.</p>

                        <p><i>Note:  For everyone who likes using Redux, you could use Redux to manage
                            the state of the monostate class's state.  A new design pattern?  The Redux-Monostate 
                            pattern?  I think yet another item on my todo list is going to be creating a simple 
                            web application using the Redux-Monostate design pattern that I just christened.</i></p>
                    </div>


                    {/*  *********** First Div - Example Class Code ***************/}
                    <div className="scroll-div" ref={node => this.first = node}>
                        <p>Consider the following class definition:</p>
                        <pre>
                            <code>
                                <p className="tab1">{"class Monostate"}</p>
                                <p className="tab1">{"{"}</p>
                                <p className="tab2">{"constructor()"}</p>
                                <p className="tab2">{"{  "}</p>
                                <p className="tab3">{"this.getStateVar = function()"}</p>
                                <p className="tab3">{"{"}</p>
                                <p className="tab4">{"return Monostate.stateVar;"}</p>
                                <p className="tab3">{"}"}</p>
                                <p className="tab3">{"this.incrementStateVar = function()"}</p>
                                <p className="tab3">{"{"}</p>
                                <p className="tab4">{"++Monostate.stateVar;"}</p>
                                <p className="tab3">{"} "}</p>
                                <p className="tab2">{"} "}</p>
                                <p className="tab1">{"}"}</p>
                                <p className="tab1">{"Monostate.stateVar = 1;"}</p>
                                <p className="tab1">{"export default Monostate;"}</p>
                            </code>
                        </pre>
                    </div>

                    {/*  *******************Second Div ***************************/}
                    <div className="container" ref={node => this.second = node}>
                        <div className="row">
                        <div className="col-sm-10">
                        </div>
                        <p>In the webpage region that follows, the Monostate class definintion was used to 
                            create two objects of the Monostate class.  The incrementStateVar method is an 
                            object method - Not a static method, and the getStateVar is also an object method and 
                            not a static method.</p>

                        <p>The object methods operate on the static data attributes and so even though there are 
                            two separate objects, they both have access to the Monostate.stateVar static data 
                            attribute.</p>

                        </div>
                        <div ref={node => this.third = node} className="row demo-window">
                            <div className="col-sm-5 ">
                                <h5 className="text-center">Object 1</h5>
                                <div className="objbtndiv">
                                    <button className="demoBtn" onClick={this.handleIncrement1}>Increment State Variable</button>
                                </div>
                                <p className="text-center">State Variable = {this.state.stateCount1}</p>

                            </div>
                            <div className="col-sm-5">
                                <h5 className="text-center">Object 2</h5>
                                <div className="objbtndiv">
                                    <button className="demoBtn" onClick={this.handleIncrement2}>Increment State Variable</button>
                                </div>
                                <p className="text-center">State Variable = {this.state.stateCount2}</p>

                            </div>
                        </div>
                    </div>

                    {/*  *******************Second Div ***************************/}
                    <div className="scroll-div" ref={node => this.third = node}>
                    <p>The Monostate design pattern meets all the requirements of the singleton pattern without 
                        the machinations of ensuring that only one object exists.  It does this in a very straight 
                        forward manner using only the existing features of Javascript.</p>

                    <p>The one shortcoming of the Monostate pattern is that the static data attributes 
                        are public because Javascript provides no mechanism for making them private.  
                        However, the Redux-Monostate design pattern provides a mechanism for making 
                        the Monostate data attributes private.</p>
                    </div>


                    {/*  *******************Second Div ***************************/}
                    <div className="scroll-div" ref={node => this.yret = node}>
                    </div>


                    
                </div>
            </div>
        )

    }

}

export default Monostate;



// WEBPACK FOOTER //
// ./src/components/EsPatterns/Monostate.js